import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'benchmarks',
  action: ActionType.READ,
};

const createPermission = {
  resource: 'benchmark',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'benchmark',
  action: ActionType.UPDATE,
};
const readPermission = {
  resource: 'benchmark',
  action: ActionType.READ,
};
const deletePermission = {
  resource: 'benchmark',
  action: ActionType.UPDATE,
};

export const Benchmark = {
  list: listPermission,
  read: readPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
